import * as Css from "./style";
import loadingIcon from "../../assets/loading-icon.png";

const Loader = () => {
  return (
    <Css.Loader>
      <img src={loadingIcon} alt="" />
    </Css.Loader>
  );
};

export default Loader;
